// ── SubscribeModal ──
import { Btn, Card, useEscape } from "../../../shared/ui";
import { useApp } from "../../../shared/appContext";

export const SubscribeModal = ({ onClose }) => {
    const { api } = useApp();
    useEscape(onClose || null);
    const base = window.location.origin;
    const token = "YOUR_FEED_TOKEN"; // replace with per-user rotatable token
    const httpsUrl = `${base}/api/getCovenantCalendarICS?token=${token}`;
    const webcalUrl = httpsUrl.replace(/^https?:/, "webcal:");
    const copy = (t) => navigator.clipboard.writeText(t);
    return (
      <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,.4)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000 }}>
        <div onClick={e=>e.stopPropagation()} style={{ maxWidth:520, width:"90%", background:"#fff", borderRadius:8 }}>
          <Card>
            <h3 style={{ marginTop:0 }}>Subscribe to the Covenant Calendar</h3>
            <p style={{ color:"var(--color-text-secondary)", fontSize:14 }}>Add this feed to Outlook or Google. It refreshes on their schedule (Outlook ~3h, Google up to 24h) — not a live push.</p>
            <label style={{ fontSize:12, fontWeight:600 }}>Outlook / Apple Calendar</label>
            <div style={{ display:"flex", gap:6, margin:"4px 0 12px" }}>
              <input readOnly value={webcalUrl} onFocus={e=>e.target.select()} style={{ flex:1, padding:"6px 8px" }} />
              <Btn onClick={()=>copy(webcalUrl)}>Copy</Btn>
            </div>
            <label style={{ fontSize:12, fontWeight:600 }}>Google Calendar (Other calendars → From URL)</label>
            <div style={{ display:"flex", gap:6, margin:"4px 0 12px" }}>
              <input readOnly value={httpsUrl} onFocus={e=>e.target.select()} style={{ flex:1, padding:"6px 8px" }} />
              <Btn onClick={()=>copy(httpsUrl)}>Copy</Btn>
            </div>
            <div style={{ textAlign:"right" }}><Btn onClick={onClose}>Close</Btn></div>
          </Card>
        </div>
      </div>
    );
  };
